import React from 'react';
import { Root } from './styled';

interface TopicsRootProps {
    isCustomizing: boolean;
}

export const TopicsRoot: React.FC<TopicsRootProps> = ({ children, isCustomizing }) => {
    return <Root className={isCustomizing ? 'sidebar-opened' : 'sidebar-closed'}>{children}</Root>;
};
